import { render } from "./CenteredLayout.vue?vue&type=template&id=1dbced48"
import script from "./CenteredLayout.vue?vue&type=script&lang=js"
export * from "./CenteredLayout.vue?vue&type=script&lang=js"

import "./CenteredLayout.vue?vue&type=style&index=0&id=1dbced48&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__